import { dateControl } from "../../../../../constants/form-control/core/common/date/date";
import { fileUploadControl } from "../../../../../constants/form-control/core/common/file/file";
import { selectRequiredControl } from "../../../../../constants/form-control/core/common/select/select-required";
import { textEditorControl } from "../../../../../constants/form-control/core/common/text-editor/text-editor";
import { clientSelectControl, locationSelectControl } from "../../../../../constants/form-control/employee/assign-location";
import { areaSelectControl } from "../../../../../constants/form-control/schedule";
import { FormControlUtil } from "../../../../../core/utils/form-control";
import { MasterService } from "../../../../../state/master/services/master.service";

export const HANDOVER_NOTES_ACTION_FORM_CONTROLS = {
    hand_over_note_fk_client_id: FormControlUtil.mergeFormControl(clientSelectControl, {
        key: 'hand_over_note_fk_client_id',
        templateOptions: FormControlUtil.mergeFormControl(clientSelectControl.templateOptions, {
            multiple: false,
            placeholder: '',
            selectOptions: {
            },
        }),
        validations: {
            validators: {
                required: true
            },
            messages: {
            },
        },
    }),
    hand_over_note_fk_location_id: FormControlUtil.mergeFormControl(locationSelectControl, {
        key: 'hand_over_note_fk_location_id', templateOptions: FormControlUtil.mergeFormControl(selectRequiredControl.templateOptions, {
            label: MasterService.masterBusinessLabel.Location,
            bindLabel: 'location_name',
            bindValue: 'location_id',
        }),
    }),
    hand_over_note_area_ids: FormControlUtil.mergeFormControl(areaSelectControl, {
        key: 'hand_over_note_area_ids',
        templateOptions: FormControlUtil.mergeFormControl(selectRequiredControl.templateOptions, {
            label:  MasterService.masterBusinessLabel.Area,
            bindLabel: 'area_name',
            bindValue: 'area_id',
        }),
        validations: {
            validators: {
            },
            messages: {
            },
        },
    }),
    hand_over_note_text: FormControlUtil.mergeFormControl(textEditorControl, {
        key: 'hand_over_note_text',
        templateOptions: FormControlUtil.mergeFormControl(textEditorControl.templateOptions, {
            placeholder: 'Note',
            label: 'Note',
        }),
    }),
    file_upload: FormControlUtil.mergeFormControl(fileUploadControl, {
        key: 'file_upload',
        templateOptions: FormControlUtil.mergeFormControl(fileUploadControl.templateOptions, {
            maxFileUpload: 1,
            labelHint: 'Drag & drop files here. JPG, PNG, MP4, MOV, PDF, MP3, JPEG, WAV are accepted.',
            multiple: false,
        }),
        validations: {
            validators: {
                allowedExtensions: ['jpg', 'png', 'mp4', 'mov', 'pdf', 'mp3', 'jpeg', 'wav'],
            },
            messages: {
            },
        },
    }),
    hand_over_note_expired_at: FormControlUtil.mergeFormControl(dateControl, {
        key: 'hand_over_note_expired_at',
        templateOptions: FormControlUtil.mergeFormControl(dateControl.templateOptions, {
            label: 'Expiry Date',
        }),
        validations: {
            validators: {
                required: true,
                max_date_no_past: true
            },
            messages: {
            },
        },
        classNames: {
            main: 'col-md-12',
        },
    }),
}